import { useRequiredContext } from "@redotech/react-util/context";
import { newWindow } from "@redotech/web-util/window";
import { UserContext } from "../app/user";
import { RedoAdminClientContext } from "../client/context";
import { createTeamAuth } from "../client/team";
import { REDO_MERCHANT_APP_URL } from "../config";

export function automationUrl(teamId: string, automationId: string): string {
  return `${REDO_MERCHANT_APP_URL}/stores/${teamId}/settings/oms/automations/${automationId}`;
}

export function useMerchantAppLogin(): (teamId: string, next?: string) => void {
  const client = useRequiredContext(RedoAdminClientContext);
  const user = useRequiredContext(UserContext);

  return (teamId, next) => {
    newWindow(async () => {
      try {
        const auth = await createTeamAuth(client, { name: user.name, teamId });
        const url = new URL("/login/token", REDO_MERCHANT_APP_URL);
        url.searchParams.set("token", auth.authToken);
        if (next) {
          url.searchParams.set("next", next);
        }
        return url.toString();
      } catch (e) {
        alert((e as Error).message);
        throw e;
      }
    });
  };
}
